module.exports = __webpack_public_path__ + "img/1736.bb79ed87.gif";